/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import { SalesOrderApiResponse } from "../../@types/DRO/SalesOrderResponse";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class ReturnOrderApi {
  public static api = new ReturnOrderApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllReturnOrders(
    page?: number,
    pageSize?: number,
    search?: string,
    type?: string,
    statusFilter?: string,
    customerFilter?: string
  ): Promise<SalesOrderApiResponse> {
    try {
      const response: AxiosResponse<SalesOrderApiResponse> =
        await this.instance.get("/erp/api/v1/inventory/sales/all", {
          params: {
            page,
            pageSize,
            search,
            type,
            statusFilter,
            customerFilter,
          },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching sales orders:", error);
      throw error;
    }
  }
}
